import { Injectable } from '@angular/core'
import { ILoyaltyCardDeleteResult } from 'app/passengers/passengers.interfaces'
import { Observable } from 'rxjs'
import { StatelessHttpService } from 'app/shared/stateless-http.service'

@Injectable()
export class LoyaltyMatasService {

    constructor(private statelessHttpService: StatelessHttpService) { }
    
    removeCardFromUserProfile(provider: number): Observable<ILoyaltyCardDeleteResult> {
        return this.statelessHttpService.delete<ILoyaltyCardDeleteResult>(`/loyalty/${provider}`)
    }

}
